module.exports = __webpack_public_path__ + "img/introduce-2.ac78c831.png";